import React, { useState } from 'react';
const reviews = [{
  text: 'Me consideré informado sobre salud. Las etiquetas, head que me di. Cuando entendí lo que es realmente la glicación y por qué con nadie 30 años de consultas médicas, sentí que algo fundamental. El mecanismo de glicación explicado de forma simple y ¡me cambió las decisiones!',
  author: 'Carlos M., 52 años — Houston, TX'
}, {
  text: 'Lo leí en una tarde y por primera vez entendí que es realmente la glicación y por qué casi nadie habla de esto.',
  author: 'Carlos M.'
}, {
  text: 'Después de mirar las etiquetas en el supermercado cambio completamente.',
  author: 'Andrea P.'
}, {
  text: 'El plan de 14 días es lo más útil. Es simple, claro y fácil de aplicar sin sentir que estás en una dieta.',
  author: 'Luis R.'
}, {
  text: 'Lo que más me gustó es cómo explica algo complejo de forma sencilla. Se entiende todo.',
  author: 'Marta G.'
}, {
  text: 'El diccionario de azúcares ocultos vale el libro por sí solo. Ahora entiendo mejor lo que compro.',
  author: 'José L.'
}];
export function Testimonials() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="py-20 md:py-28 px-4 bg-dark-secondary" data-id="element-644">
      <div className="max-w-content mx-auto" data-id="element-645">
        <div className="text-center mb-12" data-id="element-646">
          <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-647">
            LO QUE DICEN LOS LECTORES
          </span>
        </div>

        <button onClick={() => setIsOpen(!isOpen)} className="w-full bg-dark-card border border-border-subtle hover:border-gold/30 p-6 rounded-lg flex items-center justify-between transition-colors mb-8" data-id="element-648">
          <span className="font-serif text-xl text-cream" data-id="element-649">
            Lo que dicen quienes ya lo leyeron{' '}
            <span className="text-gold ml-2" data-id="element-650">★★★★★</span>
          </span>
          <span className={`text-gold transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-651">
            ▼
          </span>
        </button>

        {isOpen && <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in slide-in-from-top-4 duration-500" data-id="element-652">
            {reviews.map((review, idx) => <div key={idx} className="bg-dark-card border-l-[3px] border-red p-6 rounded-r-lg flex flex-col h-full" data-id="element-653">
                <div className="text-gold text-lg mb-4 tracking-widest" data-id="element-654">
                  ★★★★★
                </div>
                <p className="font-serif italic text-cream text-[16px] leading-relaxed mb-6 flex-grow" data-id="element-655">
                  "{review.text}"
                </p>
                <p className="font-sans font-bold text-gray-warm text-[13px]" data-id="element-656">
                  {review.author}
                </p>
              </div>)}
          </div>}
      </div>
    </section>;
}